define('common/ko/fn/trim',['knockout', 'underscore', 'common/tools'], function (ko, _, tools) {
    return ko.subscribable.fn.trim = _.memoize(function () {
        return ko.pureComputed({
            read: function () {
                return _.trim(this());
            },
            write: function (value) {
                this(_.trim(value));
            },
            owner: this
        });
    }, function () {
        return tools.objToHash(this);
    });
});

